import { render, staticRenderFns } from "./ListingDetails.vue?vue&type=template&id=620865f0&scoped=true&"
import script from "./ListingDetails.vue?vue&type=script&lang=ts&"
export * from "./ListingDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ListingDetails.vue?vue&type=style&index=0&id=620865f0&scoped=true&lang=css&"
import style1 from "./ListingDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620865f0",
  null
  
)

export default component.exports